export const VENTILATION_SYSTEMS_PATH =
  '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-ventilyacii-i-kondicionirovaniya-pod-klyuch/';

export const VENTILATION_PRELIMINARY_DESIGN_ID = '572';
export const VENTILATION_WORKING_DOCUMENTATION_ID = '825';

export const VENTILATION_SYSTEMS_CONSULTATION_TYPE = 'VENTILATION';

export const VENTILATION_SERVICE_TYPE_ID_LIST = [
  VENTILATION_PRELIMINARY_DESIGN_ID,
  VENTILATION_WORKING_DOCUMENTATION_ID,
];

export const VENTILATION_ELEMENT_BLOCK = 'landingSistemyVentilyacii';

export const SERVICE_ID_VENTILATION = '2110';
